import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="card">
        <p className="muted">Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/giris" replace />;
  }

  return children;
}
